<div class="spinner-container" *ngIf="showSpinner">
  <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
    type="ball-grid-beat" [fullScreen]="false">
    <p style="color: white"> C a r g a n d o . . . </p>
  </ngx-spinner>
</div>

<ng-container *ngIf="!this.showSpinner">
  <div class="modal-header" >
    <div>
      <label for="email" class="float-end col-form-label">Nuevo correo destino:</label>
    </div>
    <div class="col-10 row">
      <input class="form-control" id="email" [formControl]="emailFormControl"/>
      <div *ngIf="email?.invalid && email?.errors?.required && (email.dirty || email.touched)"
        class="alert alert-danger">El correo electrónico es obligatorio.
      </div>
      <div *ngIf="email?.invalid && email?.errors?.multipleEmails && (email.dirty || email.touched)"
        class="alert alert-danger">Uno o más correos electrónicos no son válidos.
      </div>
    </div>
  </div>
  <div class="modal-body text-center">    
    <div class="example-container">
      <h2>Aeroplantas</h2>

      <div cdkDropList #aeroplantasList="cdkDropList" [cdkDropListData]="aeroplantas"
        [cdkDropListConnectedTo]="[aeroplantasAsignadasList]" class="example-list" (cdkDropListDropped)="drop($event)">
        <div class="example-box" *ngFor="let item of this.aeroplantas" cdkDrag>{{item.nombre}}</div>
      </div>
    </div>

    <div class="example-container">
      <h2>Asignadas</h2>

      <div cdkDropList #aeroplantasAsignadasList="cdkDropList" [cdkDropListData]="aeroplantasAsignadas"
        [cdkDropListConnectedTo]="[aeroplantasList]" class="example-list" (cdkDropListDropped)="drop($event)">
        <div class="example-box" *ngFor="let item of this.aeroplantasAsignadas" cdkDrag>{{item.nombre}}</div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button (click)="asignarTodas()" class="btn btn-primary text-center">Asignar todas</button>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-success" [disabled]="email?.invalid" (click)="agregarCorreos()">Agregar</button>
    <button class="btn btn-secondary" (click)="cancelar()">Volver</button>
  </div>
</ng-container>